export default "__VITE_ASSET__CLL5sAQ7__"